import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		"& > *": {
			margin: theme.spacing(1),
		},
		[theme.breakpoints.down("xs")]: {
			width: "100%",
			display: "flex",
			alignItems: "center",
			flexWrap: "wrap",
			marginLeft: 0,
			"& > *": {
				margin: theme.spacing(0.5),
			},
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
